import React from 'react';
import { canonicalFor, usePageMeta } from '../hooks/usePageMeta';
import { StructuredData } from '../components/StructuredData';
import { Hero } from '../components/home/Hero';
import { TrustBand } from '../components/home/TrustBand';
import { SystemSection } from '../components/home/SystemSection';
import { ProductSystem } from '../components/home/ProductSystem';
import { ApplicationsSection } from '../components/home/ApplicationsSection';
import { StartingData } from '../components/home/StartingData';
import { ToolSelection } from '../components/home/ToolSelection';
import { SafetySection } from '../components/home/SafetySection';
import { Heritage } from '../components/home/Heritage';
import { FaqSection } from '../components/home/FaqSection';
import { ProductGuidance } from '../components/home/ProductGuidance';
export function Home() {
  usePageMeta({
    title: 'High-Rake CNC Lathe Tooling | Robertson Precision',
    description: 'Review Shear Geometry high-rake CNC lathe holders, inserts and starter kits for aluminum, copper and titanium. Call Robertson Precision at 800-397-7745.',
    canonical: canonicalFor('/')
  });
  return <>
      <StructuredData data-id="element-773" data-mp="2vvlz4qdyco9p" />
      <Hero data-id="element-774" data-mp="2qybz6gsxsu7m" />
      <TrustBand data-id="element-775" data-mp="2qy2f19ukph9u" />
      <SystemSection data-id="element-776" data-mp="2qxk9tnpxnsps" />
      <ProductSystem data-id="element-777" data-mp="2qwshqmvjod49" />
      <ApplicationsSection data-id="element-778" data-mp="2r0gctqgn17l3" />
      <StartingData data-id="element-779" data-mp="2mxjork8bwj9r" />
      <ToolSelection data-id="element-780" data-mp="2mw8k7i7277hl" />
      <SafetySection data-id="element-781" data-mp="2mwqqz8rcl43r" />
      <Heritage data-id="element-782" data-mp="2mzczbam2bnn1" />
      <FaqSection data-id="element-783" data-mp="2hxnljn7ggvv9" />
      <ProductGuidance data-id="element-784" data-mp="2hy7518cr7sbe" />
    </>;
}